import { Store } from 'redux';
import { AppActions, AppState } from '../../store/initialStateRegistration';
import { injectVideoLogo, injectVideoLogoParams } from '../../store/primaryHeader/primaryHeader.actions';
import { ClientAPIEvent } from './index';
import { InjectArticleBlockByIndexParams, injectArticleBlockByIndex } from '../../store/template/postPage/postPage.actions';

export const injectVideoLogoEvent:ClientAPIEvent = {
    name: 'injectVideoLogo',
    handlerCreator: (store: Store<AppState, AppActions>) => (params:injectVideoLogoParams) => store.dispatch(injectVideoLogo(params)),
};

export const getPageDataEvent = (createPageDataCb: (state: AppState) => object):ClientAPIEvent => ({
    name: 'getPageData',
    handlerCreator: (store: Store<AppState, AppActions>) => (callback: Function) => callback(createPageDataCb(store.getState())),
});

export const injectArticleBlockByIndexEvent:ClientAPIEvent = {
    name: 'injectArticleBlockByIndex',
    handlerCreator: (store: Store<AppState, AppActions>) => (params: InjectArticleBlockByIndexParams) => store.dispatch(injectArticleBlockByIndex(params)),
};
